import { useMemo, useState } from "react";
import { LuPin } from "react-icons/lu";
import { RiMedalFill } from "react-icons/ri";
import { cn } from "../../lib/utils";

export function TopLocationByActiveLicenses({
   topLocations = [],
   ...props
}) {
   const [viewMode, setViewMode] = useState("cities");

   const states = useMemo(() => {
      return [
         ...new Set(topLocations.map((location) => location.state))
      ]
         .sort((a, b) => a.localeCompare(b));
   }, [topLocations]);

   const cities = useMemo(() => {
      return [
         ...new Set(
            topLocations.map((location) => location.city)
         ),
      ].sort((a, b) => a.localeCompare(b));
   }, [topLocations]);

   const cityLocations = useMemo(() => {
      return [...topLocations]
         .sort((a, b) => b.quantity - a.quantity);
   }, [topLocations]);

   const stateLocations = useMemo(() => {
      const grouped = topLocations.reduce((acc, location) => {
         if (!acc[location.state]) {
            acc[location.state] = {
               state: location.state,
               quantity: 0,
            };
         }

         acc[location.state].quantity += location.quantity;

         return acc;
      }, {});

      return Object.values(grouped)
         .sort((a, b) => b.quantity - a.quantity);
   }, [topLocations]);

   function handleViewModeChange(event) {
      const mode = event.target.value;
      setViewMode(mode);
   }

   const locations = viewMode === "states" ? stateLocations : cityLocations;

   return (
      <div
         {...props}
         style={{ ...props.style }}
         className={cn("w-full h-[max(100%,fit)] border! border-(--borderColor)! rounded-(--borderRadius)! **:text-(--textColor) box-border! shadow-(--box-shadow) bg-(--containerBackgroundColor)", props.className)}
      >
         <div className="flex items-center justify-between gap-4 w-full border-b! border-(--borderColor)! px-5! py-4! box-border!">
            <div className="flex flex-row items-center gap-2 font-bold! text-[0.9rem]! whitespace-nowrap">
               <LuPin size={19} />
               <span className="font-bold! leading-[0.1]!">Top locais por licenças ativas</span>
            </div>

            <div className="flex items-center gap-2">
               <select
                  value={viewMode}
                  onChange={handleViewModeChange}
                  className="h-[14.4px] min-w-24 p-0! border-none! bg-(--containerBackgroundColor) text-xs! outline-none! cursor-pointer opacity-60!"
               >
                  <option value="states">Por estados</option>
                  <option value="cities">Por cidades</option>
               </select>
            </div>
         </div>

         <div className="w-full px-6! py-3! box-border!">
            <table className="table-auto w-full">
               <thead>
                  <tr className="text-xs! opacity-60">
                     <th className="w-12 text-left! font-medium!">

                     </th>

                     <th className="text-left! font-medium!">
                     </th>

                     <th className="text-right! font-medium!">
                     </th>
                  </tr>
               </thead>

               <tbody>
                  {locations.map((location, index) => (
                     <tr
                        key={index}
                        className="group/table-row"
                     >
                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none!">
                           {index + 1}º
                        </td>

                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none!">
                           <div className="flex flex-row items-center gap-2">
                              <span>
                                 {viewMode === "states"
                                    ? location.state
                                    : `${location.city}, ${location.state}`}
                              </span>

                              {index < 3 && (
                                 <span className="flex items-center">
                                    {index === 0 && (
                                       <RiMedalFill
                                          size={15}
                                          className="**:text-yellow-400"
                                       />
                                    )}

                                    {index === 1 && (
                                       <RiMedalFill
                                          size={15}
                                          className="**:text-gray-400"
                                       />
                                    )}

                                    {index === 2 && (
                                       <RiMedalFill
                                          size={15}
                                          className="**:text-amber-700"
                                       />
                                    )}
                                 </span>
                              )}
                           </div>
                        </td>

                        <td className="box-border! px-0! py-4.5! border-b! border-(--borderColor)! group-last/table-row:border-none! text-right! font-medium!">
                           {location.quantity}
                        </td>
                     </tr>
                  ))}

                  {!locations.length && (
                     <tr>
                        <td
                           colSpan={3}
                           className="py-8! text-center! text-sm! opacity-60"
                        >
                           Nenhuma localização encontrada.
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>
         </div>
      </div>
   );
}
